import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { _cs } from '@togglecorp/fujs';
import RawButton from '../RawButton/index.js';
import Border from '../Border/index.js';
import { TabContext } from '../TabContext.js';
import { genericMemo, setHashToBrowser } from '../../utils/index.js';
import styles from './styles.css.js';

const tabVariantToStyleMap = {
  primary: styles.primary,
  secondary: styles.secondary,
  step: styles.step
};

function Tab(props) {
  const context = React.useContext(TabContext);
  const {
    variant,
    disabled: disabledFromContext,
    ellipsize: ellipsizeFromContext
  } = context;
  const {
    activeClassName,
    className,
    name,
    disabled: disabledFromProps,
    borderWrapperClassName,
    children,
    transparentBorder,
    borderPosition = 'bottom',
    borderWidth,
    fullWidthActiveBorder,
    ellipsize: ellipsizeFromProps,
    ...otherProps
  } = props;
  const ellipsize = ellipsizeFromContext || ellipsizeFromProps;
  let isActive = false;

  if (context.useHash) {
    isActive = context.hash === name;
  } else {
    isActive = context.activeTab === name;
  }

  const disabled = disabledFromContext || disabledFromProps;
  const button = /*#__PURE__*/React.createElement(RawButton, _extends({
    className: _cs(className, styles.tab, isActive && styles.active, isActive && activeClassName, disabled && styles.disabled, ellipsize && styles.ellipsize, variant && tabVariantToStyleMap[variant]),
    onClick: context.useHash ? setHashToBrowser : context.setActiveTab,
    name: name,
    disabled: disabled,
    role: "tab",
    title: typeof children === 'string' ? children : undefined // eslint-disable-next-line react/jsx-props-no-spreading

  }, otherProps), variant === 'primary' && /*#__PURE__*/React.createElement(Border, {
    active: isActive,
    disabled: disabled,
    transparent: transparentBorder,
    fullWidthActiveBorder: fullWidthActiveBorder,
    width: borderWidth,
    position: borderPosition
  }), ellipsize ? /*#__PURE__*/React.createElement("div", {
    className: styles.ellipsizeContainer
  }, children) : children); // The clip path used for step tab does not support border
  // So we wrap it into a container and set its background as border

  if (variant === 'step') {
    return /*#__PURE__*/React.createElement("div", {
      className: _cs(styles.borderWrapper, disabled && styles.disabled, borderWrapperClassName)
    }, button);
  }

  return button;
}

var index = genericMemo(Tab);

export { index as default };
//# sourceMappingURL=index.js.map
